<mat-toolbar class="subtitulo">Frequência de Beneficiários na Unidade</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="70%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione uma unidade</mat-label>
                    <mat-select fxFlexOffset="20px" [(ngModel)]="filtroBusca.unidade" name="unidade">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of unidades" [value]="d">
                            {{d.nomeUnidade}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field fxFlex="30%">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Informe a data de frequência</mat-label>
                    <input matInput
                           fxFlexOffset="20px"
                           [max]="maxDate"
                           [min]="minDate"
                           [matDatepicker]="dataReferencia"
                           name="dataReferencia"
                           [(ngModel)]="filtroBusca.dataReferencia" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataReferencia"></mat-datepicker-toggle>
                    <mat-datepicker #dataReferencia></mat-datepicker>
                </mat-form-field>
            </div>
            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="10%" [disabled]="formulario.invalid" (click)="consultar()" *ngIf="filtroBusca.unidade && filtroBusca.unidade.idUnidade">
                    CONSULTAR
                </button>
                <button mat-raised-button fxFlex="10%" style="padding-right: 20px" (click)="limpar()">
                    LIMPAR
                </button>
            </div>

            <div *ngIf="filtroBusca.unidade && filtroBusca.unidade.idUnidade">
                <dados-unidade [unidade]="filtroBusca.unidade"></dados-unidade>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <div fxFlex="80%">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill *ngIf="mostrarTabela" >
                        <mat-form-field fxFlexOffset="20px" style="width: 100%" >
                            <mat-icon matPrefix>search</mat-icon>
                            <mat-label fxFlexOffset="20px">Informe um valor para filtrar</mat-label>
                            <input fxFlexOffset="20px" matInput (keyup)="applyFilter($event.target.value)" >
                        </mat-form-field>
                    </div>
                </div>

                <div fxFlex="20%">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill 
                         *ngIf="mostrarBotaoGerarListaFrequencia && isFiltroPreenchido()" class="botoes">
                        <button mat-raised-button (click)="gerarListaFrequencia()">
                            GERAR LISTA FREQUÊNCIA
                        </button>
                    </div>
                </div>

            </div>

            <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px" fxFlexFill>
                <div *ngIf="!mostrarTabela && mostrarBotaoGerarListaFrequencia && isFiltroPreenchido()" 
                     style="width: 50%; text-align: center; border-style: solid; border-color: coral;margin-bottom: 15px;">
                    <span style="color: blue">
                        Não há frequência de aluno nessa unidade na data informada.
                    </span>
                </div>
            </div>

            <table [fxHide]="!mostrarTabela"
                    matSort
                    mat-table
                    [dataSource]="dataSource"
                    style="margin-top: 10px">

                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef> Aluno </th>
                    <td mat-cell *matCellDef="let element;  let i = index" style="width: 300px">
                        {{element.aluno?.pessoaFisica?.nome}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="matriculaAluno">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Matrícula </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        {{element.aluno.matriculaAluno}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="datafrequencia">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Data de Frequência </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        {{element.dataFrequencia | dataSimples}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="justificativa" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                        Justificativa </th>
                    <td mat-cell *matCellDef="let element; let i = index" style="width: 400px">
                        <span [fxHide]="!element.desabilitado" style="width: 95%">
                            {{element.justificativa}}    
                        </span>
                        <mat-form-field style="width: 95%" [fxHide]="element.desabilitado">
                            <input matInput
                                    maxlength="45"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="element.justificativa">
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="presenca">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right;"> Presença</th>
                    <td mat-cell *matCellDef="let element;  let i = index" style="text-align: left;">
                        <mat-checkbox [(ngModel)]="element.presenca"
                                    [disabled]="element.desabilitado"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="onPresencaChange(element)"></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ausencia">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right;"> Ausência</th>
                    <td mat-cell *matCellDef="let element;  let i = index" style="text-align: left;">
                        <mat-checkbox [(ngModel)]="element.ausencia"
                                    [disabled]="element.desabilitado"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="onAusenciaChange(element)"></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element;">
                        <button *ngIf="perfilAcesso.altera" mat-button (click)="editar(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </form>

        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[10, 20, 40, 80]" showFirstLastButtons></mat-paginator>
        </div>

        <div [hidden]="mostrarTabela">
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </div>
    </div>


    <div *ngIf="mostrarTabela" dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

        <button *ngIf="perfilAcesso.altera" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formulario.invalid" (click)="atualizar()">
            SALVAR
        </button>

    </div>
</div>
